<template>
<div id="about">
  <div id="header">
    <header-component v-bind="subdata"></header-component>
  </div>
    <!-- ======== @Region: #highlighted ======== -->
    <div id="highlighted" class="border-bottom-0 bg-black">
      <!-- Image Banner: Use the the data-bg-img functionality to create a simple image banner Use spacer classes to make the banner larger with padding, allows for easy responsive changes too see: elements-ctas.htm To make the banner full height/screen add the attributes: data-toggle="full-height" data-offset="#header" -->
      <div class="text-center px-5 pb-7 pt-7 py-lg-8 flex-valign" data-bg-img="assets/img/backgrounds/lazaro fondo.jpg"
        data-css='{"background-position": "center bottom"}' data-toggle="full-height"
        data-breakpoint="992">
        <div data-scroll="scrollax" data-scrollax-y-ratio="1000" class="py-lg-5 pt-lg-9">
          <div class="text-center" data-animate="fadeInDown" data-animate-delay="0.2">
            <img class="main-logo-image img-fluid" src="assets/img/logo lazaro.png" width="400" height="400" >
          </div>
          <h3 class="text-white font-weight-normal main-header main-header-highlighted" data-animate="fadeInUp" data-animate-delay="0.2">
            Cerca del donante, cerca del beneficiario
          </h3>
          <hr class="mt-0 mb-5 hr-blank"/>
          <div class="row" data-animate="fadeIn" data-animate-delay="0.2">
            <div class="col-sm-12">
              <a target="_blank" href="http://www.lazzaro.io" class="btn botones1 btn-font-small padding-info" id="get-btn1" data-toggle="scroll-link">Entrar</a>
              <span class="divider"></span>
              <a target="_blank" href="https://www.youtube.com/watch?v=7VK2tfh2jjI&feature=youtu.be" class="btn botones1 btn-font-small padding-demo" id="get-btn2">Vídeo</a>
            </div>
          </div>
          <div class="row responsive-icons-padding">
            <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-right">
              <a href="" target="_blank"><img class="social-media-size" src="assets/img/icons/facebook.png"></a>
            </div>
            <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-center">
              <a href="https://twitter.com/LazaroSolutions" target="_blank"><img class="social-media-size" src="assets/img/icons/twitter.png"></a>
            </div>
            <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 text-left">
              <a href="https://www.linkedin.com/company/lazarosolutions/" target="_blank"><img class="social-media-size" src="assets/img/icons/linkedin.png"></a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="content" class="p-0 clearfix">
      <!-- Estadisticas Llamativas -->
      <div id="Estadisticas" class="bg-white">
        <div class="container" data-animate="fadeIn" data-animate-duration="0.5">
          <div class="row">
            <div class="col-lg-12 text-center margin-top-card-estadistica">
              <div class="card-estadisticas width-of-cards-estadisticas">
                <div id="carouselExampleIndicators" class="carousel slide height-of-carousel" data-ride="carousel">
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <div class="padding-inside-cards-estadisticas-short">
                        <p class="text-center p-padding-inside-stat-cards">El 24% de la población española declara haber donado en el último año</p>
                        <div class="text-right a-element-padding-inside-stats">
                            <a href="https://www.aefundraising.org/wp-content/uploads/2017/09/Perfil_donante-2016-_-resumen-ejecutivo.pdf" class="a-elements-inside-stats source-text-estadistica" target="_blank">Fundraising España (2016)</a>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="padding-inside-cards-estadisticas-short">
                        <p class="text-center p-padding-inside-stat-cards">Un tercio de la población no considera transparentes a las entidades del tercer sector</p>
                        <div class="text-right a-element-padding-inside-stats">
                            <a href="https://www.aefundraising.org/wp-content/uploads/2017/09/Perfil_donante-2016-_-resumen-ejecutivo.pdf" class="a-elements-inside-stats source-text-estadistica" target="_blank">Fundraising España (2016)</a>
                        </div>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="padding-inside-cards-estadisticas-long">
                        <p class="text-center p-padding-inside-stat-cards">Aproximadamente el 66% de los donantes afirman que estarían dispuestos a utilizar una app que permitiera donar en dos pasos y con puntos canjeables</p>
                        <div class="text-right a-element-padding-inside-stats">
                            <a href="http://www.nptechforgood.com/2017/08/24/media-advisory-2017-global-trends-in-giving-report-to-be-released-september-12/" class="a-elements-inside-stats source-text-estadistica" target="_blank">Non Profit Tech for Good (2017)</a>
                          </div>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="padding-inside-cards-estadisticas-short">
                        <p class="text-center p-padding-inside-stat-cards">El 56% de las personas no donan por falta de confianza y transparencia</p>
                        <div class="text-right a-element-padding-inside-stats">
                            <a href="https://www.aefundraising.org/wp-content/uploads/2017/09/Perfil_donante-2016-_-resumen-ejecutivo.pdf" class="a-elements-inside-stats source-text-estadistica" target="_blank">Fundraising España (2016)</a>
                          </div>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="padding-inside-cards-estadisticas-super-long">
                        <p class="text-center p-padding-inside-stat-cards">"Cuando decidimos dar nuestro dinero a una organización humanitaria, nos gusta saber dónde está yendo a parar. Por eso, la transparencia en las cuentas de donaciones a ONG es esencial para los donantes."</p>
                        <div class="text-right a-element-padding-inside-stats">
                            <a href="#" class="a-elements-inside-stats source-text-estadistica" target="_blank">Acnur-Donaciones a ONG</a>
                          </div>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="padding-inside-cards-estadisticas-super-long">
                        <p class="text-center p-padding-inside-stat-cards">92% de los donantes a nivel mundial  dice que es importante que las las organizaciones de caridad realicen un esfuerzo conjunto para proteger su contacto e información financiera de las violaciones de datos.</p>
                        <div class="text-right a-element-padding-inside-stats">
                            <a href="http://www.nptechforgood.com/2017/08/24/media-advisory-2017-global-trends-in-giving-report-to-be-released-september-12/" class="a-elements-inside-stats source-text-estadistica" target="_blank">Non Profit Tech for Good (2017)</a>
                          </div>
                      </div>
                    </div>
                    <!-- <div class="carousel-item">
                      <div class="padding-inside-cards-estadisticas-super-long">
                        <p class="text-center p-padding-inside-stat-cards">92% de los donantes a nivel mundial  dice que es importante que las las organizaciones de caridad realicen un esfuerzo conjunto para proteger su contacto e información financiera de las violaciones de datos.</p>
                        <div class="text-right a-element-padding-inside-stats">
                            <a href="http://www.europapress.es/epsocial/cooperacion-desarrollo/noticia-cual-perfil-donante-ong-espana-20170720153653.html" class="a-elements-inside-stats source-text-estadistica" target="_blank">Non Profit Tech for Good (2017)</a>
                          </div>
                      </div>
                    </div> -->
                  </div>
                  <hr class="mt-0 mb-2 hr-blank"/>
                  <ol class="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="5"></li>
                    <!-- <li data-target="#carouselExampleIndicators" data-slide-to="4"></li> -->
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Por Que Lázaro & Que-->
      <div id="Lazaro" class="bg-white">
        <!-- Por que Lazaro -->
        <div class="container p-4 py-lg-5 padding-porque-lazaro" data-animate="fadeIn" data-animate-duration="0.5">
          <h3 class="text-center sections-title">Por qué Lázaro</h3>
          <hr class="mt-0 mb-5 hr-blank"/>
          <div class="row align-items-center row-padding-right">
            <!-- <div class="cards-porque-lazaro"> -->
              <div class="col-md-3 porque-image-icon-alignment">
                  <img class="porque-image-icon" width="80" height="80" src="assets/img/icons/Porque2.png">
              </div> 
              <div class="col-md-9">
                <div class="card-flapping">
                  <div class="task">
                    <div class="abstract">
                    <h4 class="header-cards">El donante necesita conocer el destino real de la donación y el verdadero impacto generado</h4>
                    </div>
                    <div class="details">
                    <div class="details__inner text-inside-card-responsive">
                      <p>· Poder confiar en que la donación ayudará a los que lo necesitan de verdad.</p>
                      <p>· Conocer el verdadero impacto generado en la sociedad.</p>
                      <p>· Interactuar de una forma atractiva y tener mayor protagonismo.</p>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <hr class="mt-0 myb-5-4 hr-blank"/>
          <div class="row align-items-center row-padding-right">
            <div class="col-md-3 porque-image-icon-alignment">
                <img class="porque-image-icon" width="80" height="80" src="assets/img/icons/Porque1.png">
            </div>
            <div class="col-md-9">
              <div class="card-flapping">
                <div class="task">
                  <div class="abstract">
                  <h4 class="header-cards">El tercer sector precisa de un impulso hacia las nuevas tecnologías</h4>
                  </div>
                  <div class="details">
                  <div class="details__inner text-inside-card-responsive">
                    <p>· Adaptar las nuevas tecnologías a la realidad de las organizaciones.</p>
                    <p>· Crear una relación más fuerte y cercana entre donantes y ONGs a través de las tendencias más innovadoras.</p>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Que es Lazaro -->
        <div class="container p-4 py-lg-5" data-animate="fadeIn" data-animate-duration="0.5">
          <!-- Missing Rows and Colums -->
          <div class="row">
            <div class="col-md-12">
              <h3 class="text-center sections-title">Qué es Lázaro</h3>
            </div>
          </div>
          <hr class="mt-0 mb-5 hr-blank"/>
          <div class="row align-items-center">
            <div class="col-md-12 text-center">
              <p class="que-lazaro-text">Lázaro es una plataforma basada en tecnología blockchain que une a las ONGs más innovadoras y disruptivas y a las personas concienciadas de colaborar en la elaboración de un mundo más sostenible de una forma eficaz.</p>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-5 w-50 mx-auto" />

      <!-- Beneficios -->
      <div id="Beneficios" class="bg-white p-3 py-lg-5">
        <div class="container" data-animate="fadeIn" data-animate-duration="0.6">
          <!-- Titulo -->
          <div class="row">
            <div class="col-lg-12">
              <h3 class="text-center sections-title">Beneficios</h3>
            </div>
          </div>
          <hr class="mt-0 mb-3 hr-blank"/>
          <!-- Butones de controles -->
          <div class="row">
            <div id="botones-filtro" class="col-lg-12 text-center">
              <button class="btn botones active-boton" onclick="filterSelectionBeneficios('ONG')">ONGs</button>
              <span class="espacio-botones-subsecciones"></span>
              <button class="btn botones" onclick="filterSelectionBeneficios('donantes')">Donantes</button>
            </div>
          </div>
        </div>  
        <!-- Cartas de beneficios -->
        <!-- If this is a container, then there should be a standard for all sectionst that
        would be similar to this one. -->
        <div class="container card-container" data-animate="fadeIn" data-animate-duration="0.6">
          <div class="cards padding-beneficios-cards">
            <!-- Opciones ONG -->
            <div class="row">
              <!-- Multiplica donaciones -->
              <!-- <div class="col-md-6 text-right"> -->
                <div class="card ONG">
                    <a href="#" class="card-text-decoration" data-toggle="modal" data-target="#MultiplicaDonaciones">
                      <div class="card-image-position text-center">
                        <img class="img-card-icons-size" src="assets/img/icons/megaphone.png">
                      </div>
                      <hr class="mt-0 mb-2 hr-blank"/>
                      <div class="text-center">
                        <h5 class="titulo-texto-carta">Multiplica las donaciones</h5>
                        <hr class="mb-2 w-80 mx-auto" />
                        <p class="extra-margin-cards card-text-margin">La oportunidad de tener un canal directo con personas dispuestas a colaborar por una sociedad más justa</p>
                      </div>
                    </a>
                </div>
              <!-- </div> -->
              <!-- Tecnologia Blockchain -->
              <!-- <div class="col-md-6 text-left"> -->
                <div class="card ONG">
                  <a href="#" class="card-text-decoration" data-toggle="modal" data-target="#TecnologiaBlockchainDonante">
                    <div class="card-image-position text-center">
                      <img class="img-card-icons-size" src="assets/img/icons/blockchain.png">
                    </div>
                    <hr class="mt-0 mb-2 hr-blank"/>
                    <div class="text-center">
                      <h5 class="titulo-texto-carta">Tecnología Blockchain</h5>
                      <hr class="mb-2 w-80 mx-auto" />
                      <p class="card-text-margin">La tecnología que va a revolucionar el mundo, adaptada a las necesidades de las organizaciones sociales</p>
                    </div>
                  </a>
                </div>
              <!-- </div> -->
            </div>
            <div class="row">
              <!-- <div class="col-md-6 text-right"> -->
                <!-- Reportes de impacto -->
                <div class="card ONG">
                  <a href="#" class="card-text-decoration" data-toggle="modal" data-target="#ReportesImpactos">
                    <div class="card-image-position text-center">
                      <img class="img-card-icons-size" src="assets/img/icons/chart.png">
                    </div>
                    <hr class="mt-0 mb-2 hr-blank"/>
                    <div class="text-center">
                      <h5 class="titulo-texto-carta">Reportes de impacto</h5>
                      <hr class="mb-2 w-80 mx-auto" />
                      <p class="extra-margin-cards card-text-margin">Informes personalizados al alcance de tu organización, que mostrarán datos clave sobre los donantes y el impacto generado</p>
                    </div>
                  </a>
                </div>
              <!-- </div> -->
              <!-- <div class="col-md-6 text-left"> -->
                <!-- Sello de transparencia -->
                <div class="card ONG">
                    <a href="#" class="card-text-decoration" data-toggle="modal" data-target="#SelloTransparencia">
                      <div class="card-image-position text-center">
                        <img class="img-card-icons-size" src="assets/img/icons/transparencia.png">
                      </div>
                      <hr class="mt-0 mb-2 hr-blank"/>
                      <div class="text-center">
                        <h5 class="titulo-texto-carta">Sello de transparencia</h5>
                        <hr class="mb-2 w-80 mx-auto" />
                        <p class="card-text-margin">Lázaro tiene la capacidad de auditar los proyectos y mostrar la veracidad de los datos mostrados</p>
                      </div>
                    </a>
                </div>
              <!-- </div> -->
            </div>
            <!-- Opciones donantes -->
            <div class="row">
              <!-- <div class="col-md-6 text-right"> -->
                <!-- Trazabilidad transparente -->
                <div class="card donantes">
                  <a href="#" class="card-text-decoration" data-toggle="modal" data-target="#ProcesoTransparente">
                    <div class="card-image-position text-center">
                      <img class="img-card-icons-size" src="assets/img/icons/transparencia.png">
                    </div>
                      <hr class="mt-0 mb-2 hr-blank"/>
                    <div class="text-center">
                      <h5 class="titulo-texto-carta card-titles-margins">Trazabilidad de la donación</h5>
                      <hr class="mb-2 w-80 mx-auto" />
                      <p class="card-text-margin">Conoce el destino real de la donación y el impacto generado con tu aportación</p>
                    </div>
                  </a>
                </div>
              <!-- </div> -->
              <!-- <div class="col-md-6 text-left"> -->
                <!-- Amplia Causas -->
                <div class="card donantes">
                  <a href="#" class="card-text-decoration" data-toggle="modal" data-target="#TecnologiaBlockchainONG">
                    <div class="card-image-position text-center">
                      <img class="img-card-icons-size" src="assets/img/icons/diversifica.png">
                    </div>
                    <hr class="mt-0 mb-2 hr-blank"/>
                    <div class="text-center">
                      <h5 class="titulo-texto-carta">Amplia varidad de causas</h5>
                      <hr class="mb-2 w-80 mx-auto" />
                      <p class="card-text-margin">Amplia variedad de proyectos en una misma plataforma. Colabora en las causas sociales con las que te sientas más identificado</p>
                    </div>
                  </a>
                </div>
              <!-- </div> -->
            </div>
            <div class="row">
              <!-- <div class="col-md-6 text-right"> -->
                <!-- Avances del proyecto -->
                <div class="card donantes">
                  <a href="#" class="card-text-decoration" data-toggle="modal" data-target="#VisitaProyecto">
                    <div class="card-image-position text-center">
                      <img class="img-card-icons-size" src="assets/img/icons/avances.png">
                    </div>
                    <hr class="mt-0 mb-2 hr-blank"/>
                    <div class="text-center">
                      <h5 class="titulo-texto-carta">Conoce todos los avances del proyecto</h5>
                      <hr class="mb-2 w-80 mx-auto" />
                      <p class="card-text-margin">Información detallada del proyecto en todas las fases, de una manera atractiva y cercana</p>
                    </div>
                  </a>
                </div>
              <!-- </div> -->
              <!-- <div class="col-md-6 text-left"> -->
                <!-- Integrate en una comunidad -->
                <div class="card donantes">
                  <a href="#" class="card-text-decoration" data-toggle="modal" data-target="#VariedadCausas">
                    <div class="card-image-position text-center">
                      <img class="img-card-icons-size" src="assets/img/icons/integrate.png">
                    </div>
                    <hr class="mt-0 mb-2 hr-blank"/>
                    <div class="text-center">
                      <h5 class="titulo-texto-carta card-titles-margins">Se parte de una comunidad social comprometida</h5>
                      <hr class="mb-2 w-80 mx-auto" />
                      <p class="card-text-margin">Únete a nuestra plataforma y colabora en conjunto con otras personas con tus mismos ideales</p>
                    </div>
                  </a>
                </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-5 w-50 mx-auto" />

      <!-- Como Partipar -->
      <div id="Participar" class="bg-white p-3 py-lg-5">
        <div class="container" data-animate="fadeIn" data-animate-duration="0.6">
          <div class="row">
            <div class="col-lg-12">
              <h3 class="text-center sections-title">Cómo Participar</h3>
            </div>
          </div>
          <hr class="mt-0 mb-3 hr-blank"/>
          <!-- Butones de controles -->
          <div class="row">
            <div id="botones-filtro-participar" class="col-md-12 text-center">
              <button class="btn botones active-boton-participar" onclick="filterSelectionParticipar('ONG')">ONGs</button>
              <span class="espacio-botones-subsecciones"></span>
              <button class="btn botones" onclick="filterSelectionParticipar('donantes')">Donantes</button>
            </div>
          </div>
        </div>
        <hr class="mt-0 mb-6 hr-blank"/>
        <div class="container" data-animate="fadeIn" data-animate-duration="0.6">
          <div class="col-md-12 text-center">
            <!-- ONG -->
            <!-- 1st step -->
            <div class="row align-items-center right-margin-beneficios-cards espacio-de-como-participar ONG">
              <div class="col-md-3 text-center">
                <img class="size-of-participar-number" width="90" height="90" src="assets/img/numbers/1.4.png">
              </div>
              <div class="col-md-9 text-left">
                <div class="como-participar">
                  <div class="text-como-participar-outter">
                    <h4 class="titulo-texto-carta titulo-texto-como-participar">Únete</h4>
                    <hr class="mt-0 mb-3 hr-blank"/>
                    <p class="text-como-participar-inner">Envíanos un correo a <a href="mailto:info@lázaro.io" class="texto-participar">info@lázaro.io</a> para gestionar tus proyectos en la plataforma, rápido nos pondremos en contacto para facilitar los trámites y las credenciales de nuestra primera fase versión beta.</p> 
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-0 mb-6 hr-blank"/>
            <!-- 2nd step -->
            <div class="row align-items-center right-margin-beneficios-cards espacio-de-como-participar ONG">
              <div class="col-md-3 text-center">
                <img class="size-of-participar-number" width="90" height="90" src="assets/img/numbers/2.1.png">
              </div>
              <div class="col-md-9 text-left">
                <div class="como-participar">
                  <div class="text-como-participar-outter">
                    <h4 class="titulo-texto-carta titulo-texto-como-participar">Sube tus proyectos</h4>
                    <hr class="mt-0 mb-3 hr-blank"/>
                    <p class="text-como-participar-inner">Sube de manera sencilla e intuitiva todos los proyectos de tu ONG a la plataforma, estarán accesibles a toda la comunidad donante a nivel mundial.</p> 
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-0 mb-6 hr-blank"/>
            <!-- 3rd step -->
            <div class="row align-items-center right-margin-beneficios-cards espacio-de-como-participar ONG">
              <div class="col-md-3 text-center">
                <img class="size-of-participar-number" width="90" height="90" src="assets/img/numbers/3.png">
              </div>
              <div class="col-md-9 text-left">
                <div class="como-participar">
                  <div class="text-como-participar-outter">
                    <h4 class="titulo-texto-carta titulo-texto-como-participar">Retira tus fondos</h4>
                    <hr class="mt-0 mb-3 hr-blank"/>
                    <p class="text-como-participar-inner">Retira los fondos para financiar tus proyectos y mantén informados a todos los donantes con imágenes, vídeos, facturas, comentarios, sorteos, etc.</p> 
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-0 mb-6 hr-blank"/>
            <!-- 4th step -->
            <div class="row align-items-center right-margin-beneficios-cards espacio-de-como-participar ONG">
              <div class="col-md-3 text-center">
                <img class="size-of-participar-number" width="90" height="90" src="assets/img/numbers/4.png">
              </div>
              <div class="col-md-9 text-left">
                <div class="como-participar">
                  <div class="text-como-participar-outter">
                    <h4 class="titulo-texto-carta titulo-texto-como-participar">Genera reportes de impacto</h4>
                    <hr class="mt-0 mb-3 hr-blank"/>
                    <p class="text-como-participar-inner">Genera reportes de todos tus proyectos y donantes, con información relevante acerca de la actividad generadas.</p> 
                  </div>
                </div>
              </div>
            </div>
            <!-- Donantes -->
            <!-- 1st step -->
            <div class="row align-items-center right-margin-beneficios-cards espacio-de-como-participar donantes">
              <div class="col-md-3 text-center">
                <img class="size-of-participar-number" width="90" height="90" src="assets/img/numbers/1.4.png">
              </div>
              <div class="col-md-9 text-left">
                <div class="como-participar">
                  <div class="text-como-participar-outter">
                    <h4 class="titulo-texto-carta titulo-texto-como-participar">Únete</h4>
                    <hr class="mt-0 mb-3 hr-blank"/>
                    <p class="text-como-participar-inner">Crea una cuenta en nuestra plataforma para ver los proyectos de tu interés.</p> 
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-0 mb-6 hr-blank"/>
            <!-- 2nd step -->
            <div class="row align-items-center right-margin-beneficios-cards espacio-de-como-participar donantes">
              <div class="col-md-3 text-center">
                <img class="size-of-participar-number" width="90" height="90" src="assets/img/numbers/2.1.png">
              </div>
              <div class="col-md-9 text-left">
                <div class="como-participar">
                  <div class="text-como-participar-outter">
                    <h4 class="titulo-texto-carta titulo-texto-como-participar">Elige tu proyecto</h4>
                    <hr class="mt-0 mb-3 hr-blank"/>
                    <p class="text-como-participar-inner">Navega de una manera interactiva y única en donde verás tus proyectos deasedos.</p> 
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-0 mb-6 hr-blank"/>
            <!-- 3rd step -->
            <div class="row align-items-center right-margin-beneficios-cards espacio-de-como-participar donantes">
              <div class="col-md-3 text-center">
                <img class="size-of-participar-number" width="90" height="90" src="assets/img/numbers/3.png">
              </div>
              <div class="col-md-9 text-left">
                <div class="como-participar">
                  <div class="text-como-participar-outter">
                    <h4 class="titulo-texto-carta titulo-texto-como-participar">Dona</h4>
                    <hr class="mt-0 mb-3 hr-blank"/>
                    <p class="text-como-participar-inner">Cuando escogas tu proyecto, puedes donar desde €1 y sin compromiso alguno.</p> 
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-0 mb-6 hr-blank"/>
            <!-- 4th step -->
            <div class="row align-items-center right-margin-beneficios-cards espacio-de-como-participar donantes">
              <div class="col-md-3 text-center">
                <img class="size-of-participar-number" width="90" height="90" src="assets/img/numbers/4.png">
              </div>
              <div class="col-md-9 text-left">
                <div class="como-participar">
                  <div class="text-como-participar-outter">
                    <h4 class="titulo-texto-carta titulo-texto-como-participar">Comparte</h4>
                    <hr class="mt-0 mb-3 hr-blank"/>
                    <p class="text-como-participar-inner">Hazle saber a tus amigos(as) cuanto te apasiona un proyecto para que ellos ayuden.</p> 
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-0 mb-6 hr-blank"/>
          </div>
        </div>
      </div>
      <hr class="mt-0 mb-3 hr-blank"/>
      <!-- Conócenos -->
      <div id="Conocenos" class="div-conocenos py-lg-custom-conocenos p-custom-conocenos" data-bg-img="assets/img/backgrounds/conocenos background picture.png" data-css='{"background-position": "center bottom"}' data-animate="fadeIn" data-animate-duration="0.6">
        <!-- Title -->
        <div class="row">
          <div class="col-md-12 text-center">
            <p class="sections-title">Conócenos</p>
          </div>
        </div>
        <!-- Subtitle -->
        <div class="row">
          <div class="col-md-12 text-center">
            <p class="conocenos-subtitle-text">Nos une la pasión por la innovación tecnológica</p>
          </div>
        </div>
        <hr class="mt-0 mb-5 hr-blank"/>
        <!-- Text -->
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-md-8">
            <p class="conocenos-text" >Nuestro equipo está formado por un grupo multicultural de jóvenes innovadores con experiencia en diferentes áreas y con un mismo objetivo: participar en la elaboración de un planeta más justo y sostenible a través de las tecnologías más innovadoras.</p>
          </div>
          <div class="col-md-2"></div>
        </div>
      </div>
      <hr class="mt-0 mb-5 hr-blank"/>

      <!-- Equipo -->
      <div id="Equipo" class="bg-white p-3 py-lg-5">
        <div class="container" data-animate="fadeIn" data-animate-duration="0.6">
          <div class="row">
            <div class="col-lg-12">
              <h3 class="text-center sections-title">Equipo</h3>
            </div>
          </div>
        </div>
        <hr class="mt-0 mb-5 hr-blank"/>
        <div id="Foto de equipo" class="container" data-animate="fadeIn" data-animate-duration="0.6">
          <div class=row>
            <!-- Ed -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="text-center">
                <p>Edgardo<br>Reinoso</p>
                <img src="assets/img/shield-picture/Ed.png" alt="Edgardo Reinoso">
                <!-- <div class="shield">
                  <img src="assets/img/shield-picture/Ed.png" alt="Edgardo Reinoso" class="image">
                  <div class="overlay-conocenos">
                    <div class="text">Dando oportunidad a personas que la necesitan es mi mayor motivación</div>
                  </div>
                </div> -->
                <hr class="mt-0 mb-2 hr-blank"/>
                <a class="linkedin-logo-responsive" href="https://www.linkedin.com/in/edgardo-reinoso-135683108/"><img width="35" height="30" src="assets/img/icons/linkedin_logo.png"></a>
              </div>
            </div>
            <!-- Ivan -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-top-equipo-responsive-one-column">
              <div class="text-center">
                <p>Iván<br>Saiz</p>
                <img src="assets/img/shield-picture/Ivan.png" alt="Ivan Saiz">
                <!-- <div class="shield">
                  <img src="assets/img/shield-picture/Ivan.png" alt="Ivan Saiz" class="image">
                  <div class="overlay-conocenos">
                    <div class="text">Why not technology in the third sector?</div>
                  </div>
                </div> -->
                <hr class="mt-0 mb-2 hr-blank"/>
                <a class="linkedin-logo-responsive" href="https://www.linkedin.com/in/iván-saiz-de-castro-830217135/"><img width="35" height="30" src="assets/img/icons/linkedin_logo.png"></a>
              </div>
            </div>
            <!-- Jaime -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-top-equipo-responsive-one-column">
              <div class="text-center">
                <p>Jaime<br>Inchaurraga</p>
                <img src="assets/img/shield-picture/Jaime.png" alt="Jaime Inchaurraga">
                <!-- <div class="shield">
                  <img src="assets/img/shield-picture/Ivan.png" alt="Ivan Saiz" class="image">
                  <div class="overlay-conocenos">
                    <div class="text">Why not technology in the third sector?</div>
                  </div>
                </div> -->
                <hr class="mt-0 mb-2 hr-blank"/>
                <a class="linkedin-logo-responsive" href="https://www.linkedin.com/in/jaimeinchaurraga/"><img width="35" height="30" src="assets/img/icons/linkedin_logo.png"></a>
              </div>
            </div>
            <!-- Jose -->
            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-top-equipo-responsive-one-column">
              <div class="text-center">
                <p>José María<br>Navarro</p>
                <img src="assets/img/shield-picture/Jose.png" alt="Jose Maria Navarro">
                <!-- <div class="shield">
                  <img src="assets/img/shield-picture/Ivan.png" alt="Ivan Saiz" class="image">
                  <div class="overlay-conocenos">
                    <div class="text">Why not technology in the third sector?</div>
                  </div>
                </div> -->
                <hr class="mt-0 mb-2 hr-blank"/>
                <a class="linkedin-logo-responsive" href="https://www.linkedin.com/in/josé-mar%C3%ADa-navarro-m-martinez-avial-80517b93/"><img width="35" height="30" src="assets/img/icons/linkedin_logo.png"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-0 mb-5 hr-blank"/>
      <!-- Line Reserved when having partners -->
      <!-- <hr class="mb-5 w-50 mx-auto" /> -->
    </div>

  <!-- ======== @Region: #footer ======== -->
  <footer id="footer" class="p-0 footer-light" style="border-top: 0px">
    <footer-component></footer-component>
  </footer>
</div>
</template>

<script src="../../assets/scripts/min/lazaro-script.min.js"></script>

<script>
import headerComponent from '../../components/headerComponent.vue'
import footerComponent from '../../components/footerComponent.vue'

export default {
    metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Conócenos',  
    link: [
      { rel: 'canonical', href: 'https://fundraising.lazzaro.io/about' }
    ]       
    },
    components: {
    headerComponent,
    footerComponent,
    },
}
</script>
